import React from 'react';
import clsx from 'clsx';

function Pagination({ currentPage, totalPages, onPageChange }) {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const PageButton = ({ page }) => (
    <button
      onClick={() => onPageChange(page)}
      className={clsx(
        "px-3 py-1 rounded-md text-sm font-medium",
        currentPage === page
          ? "bg-gold text-white"
          : "bg-slate-200 text-slate-700 hover:bg-slate-300"
      )}
    >
      {page}
    </button>
  );

  return (
    <nav className="flex items-center justify-center gap-2"> {/* Changed to justify-center */}
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className="px-3 py-1 rounded-md text-sm font-medium bg-slate-200 text-slate-700 hover:bg-slate-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>

      <PageButton page={currentPage} />
      
      <button
        onClick={handleNext}
        disabled={currentPage >= totalPages}
        className="px-3 py-1 rounded-md text-sm font-medium bg-slate-200 text-slate-700 hover:bg-slate-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </nav>
  );
}

export default Pagination;